module.exports = "<app-account-list></app-account-list>\r\n"